import { Injectable, OnDestroy } from '@angular/core';
import { Transporter } from '../dataModels/transporter';

@Injectable()
export class CounterService implements OnDestroy {
    private intervalHandler: object = {};

    public update(transporter: Transporter) {
        let id = transporter && transporter.BasicDetails && transporter.BasicDetails.Id;

        if (id) {
            this.addCounter(id, transporter);
        }
    }

    public dispose(transporter) {
        let id = transporter && transporter.BasicDetails && transporter.BasicDetails.Id;

        if (id) {
            this.clearTimer(id);
        }
    }

    addCounter(id: number, transporter: Transporter) {
        // clear any previous interval
        this.clearTimer(id);

        let state: any = transporter && transporter.State && transporter.State.State;

        if (!state)
            return;

        let fns = [];
        // number of seconds since 1/1/1970 since now
        let now = (new Date(Date.now())).getTime() / 1000;


        // Movement
        if (state.Movement) {
            if (state.Movement.StatusCounter >= 0) {

                // number of seconds since 1/1/1970 since the car is parked or idle
                let secondsParkingIdle = state.Movement.StatusCounter;

                let diffParkingIdle = Math.floor(now - secondsParkingIdle);
                state.Movement.StatusCounterFormatted = this.formatTime(diffParkingIdle);

                fns.push(() => {
                    diffParkingIdle++;
                    state.Movement.StatusCounterFormatted = this.formatTime(diffParkingIdle);
                });
            }
        }

        // Connectivity
        if (state.DeviceBatteryConnection) {
            let secondsConnectivity = state.DeviceBatteryConnection.StatusCounter;

            if (secondsConnectivity && secondsConnectivity >= 0) {
                let diffConnectivity = Math.floor(now - secondsConnectivity);
                state.DeviceBatteryConnection.StatusCounterFormatted = this.formatTime(diffConnectivity);

                fns.push(() => {
                    diffConnectivity++;
                    state.DeviceBatteryConnection.StatusCounterFormatted = this.formatTime(diffConnectivity);
                });
            }
        }

        let n = fns.length;
        if (n > 0) {
            this.intervalHandler[id] = window.setInterval(() => {
                for (let i = 0; i < n; i++) fns[i]();
            }, 1000);

            window["time"] = window["time"] || {};
            window["time"][id] = n;
        }
    }

    formatTime(seconds): string {
        if (seconds >= 0) {
            let minutes: any = Math.floor(seconds / 60);
            seconds -= minutes * 60;

            let hours: any = Math.floor(minutes / 60);
            minutes -= hours * 60;

            if (minutes < 10) minutes = '0' + minutes;
            if (seconds < 10) seconds = '0' + seconds;
            if (hours > 0) {
                if (hours < 10) hours = '0' + hours;
                return hours + ":" + minutes + ":" + seconds;
            } else {
                return minutes + ":" + seconds;
            }

            //let res = [];
            //if (hours)
            //    res.push((hours < 10 ? "0" : "") + hours);
            //res.push((minutes < 10 ? "0" : "") + minutes);
            //res.push((seconds < 10 ? "0" : "") + seconds);
            //return res.join(":");
        }
        return "";
    }

    clearTimer(id = undefined) {
        //if (!window["time"]) window["time"] = {};
        //delete window["time"][this.intervalHandler];
        //console.log("destroy interval", this.intervalHandler);

        if (!id) {
            for (let _id in this.intervalHandler) {
                this.intervalHandler[_id] && clearInterval(this.intervalHandler[_id]);
            }
            window["time"] = {};
        } else {
            this.intervalHandler[id] && clearInterval(this.intervalHandler[id]);
            window["time"] = window["time"] || {};
            delete window["time"][id];
        }
    }

    ngOnDestroy() {
        this.clearTimer();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/counter.service.ts